import { useEffect, useState } from 'react';

import { Completed, Error, InProgress, MissingInput, ONCORAD } from '@/assets/icons';
import { OrganLinkProgress } from '@/shared/model';

type ProgressIndicatorProps = {
  progress: null | OrganLinkProgress;
};

export function ProgressIndicator({ progress }: ProgressIndicatorProps) {
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    switch (progress) {
      case 'Completed':
        setImageUrl(Completed);
        break;
      case 'Error':
        setImageUrl(Error);
        break;
      case 'InProgress':
        setImageUrl(InProgress);
        break;
      case 'missingInput':
        setImageUrl(MissingInput);
        break;
      case 'oncorad':
        setImageUrl(ONCORAD);
        break;
      default:
        setImageUrl('');
    }
  }, [progress]);

  if (!progress) {
    return null;
  }

  return <img alt={progress} className="size-6 pr-2" src={imageUrl} />;
}
